import React from 'react';
import { ButtonBase } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { buttonBaseStyles as buttons } from 'styles/designConstants';

const useStyles = makeStyles({
  root: {
    ...buttons.root,
    borderRadius: '2px',
    fontSize: 13,
    height: 35,
    lineHeight: '16px',
    width: 55,
  },
  // Button roles, as identified in the design palette
  primary: buttons.primary,
  secondary: buttons.secondary,
  negative: buttons.negative,
  dashboard: buttons.dashboard,
});

const ButtonTable = (props: IOwnProps) => {
  const classes = useStyles(props);
  let buttonRoleStyle;

  switch (props.buttonRole) {
    case 'secondary':
      buttonRoleStyle = classes.secondary;
      break;
    case 'negative':
      buttonRoleStyle = classes.negative;
      break;
    case 'dashboard':
      buttonRoleStyle = classes.dashboard;
      break;
    default:
      buttonRoleStyle = classes.primary;
  }

  return (
    <ButtonBase
      data-testid={props.testidProp}
      className={`${classes.root} ${buttonRoleStyle}`}
      onClick={props.handleClick}
      disabled={props.disabled}
      focusRipple
    >
      {props.children}
    </ButtonBase>
  );
};

export interface IOwnProps {
  buttonRole: string;
  children: any;
  disabled?: boolean;
  handleClick?: () => void;
  testidProp?: string;
}

export default ButtonTable;
